<template>
  <div>
    <div class="row">
      <div class="input-group mb-3">
        <div class="custom-file">
          <input
            id="file-signature-selector"
            type="file"
            class="custom-file-input"
            @change="uploadFile($event)"
            accept="image/png"
          >
          <label
            class="custom-file-label"
            for="file-signature-selector"
          >
            {{ fileName || 'Seleccionar archivo' }}
          </label>
        </div>
      </div>
    </div>
    <div class="row" v-if="errorSize">
      <div class="alert alert-danger" role="alert">
        Ups! la imagen debe medir 440 x 320px
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileSignatureSelector',
  data() {
    return {
      errorSize: false,
      fileName: ''
    };
  },
  methods: {
    async uploadFile(event) {
      if (!event.target.files || !event.target.files[0]) {
        return;
      }
      const file = event.target.files[0];
      const $this = this;
      $this.fileName = file.name;
      $this.errorSize = false;
      const $URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = $URL.createObjectURL(file);
      img.onload = function readImage() {
        if (this.width !== 440 || this.height !== 320) {
          $this.errorSize = true;
        } else {
          const reader = new FileReader();
          reader.onload = function loadFile(loadFileEvent) {
            const png = loadFileEvent.target.result;
            $this.$emit('input', { png });
          };
          reader.readAsDataURL(file);
        }
      };
      img.src = objectUrl;
    }
  }
};
</script>

<style scoped>
.custom-file-input ~ .custom-file-label::after {
  content: "Buscar";
}
</style>
